import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock, BlockType, SettingType, TibboDataType,
} from '@appblocks/codegeneration/types';

export default class Tibbit_40_1 extends BaseTibbit {
    range = 5000;

    constructor() {
        super();
        this.id = 'tibbit_40_1';
        this.name = 'Tibbit 40_1';
        this.fileLinks = [
            // 'ssi\\ssi.tbs',
            // 'ssi\\ssi.tbh',
        ];
        this.files = [
            'libraries/super_i2c/super_i2c.tbh',
            'libraries/super_i2c/super_i2c.tbs',
            'libraries/tibbits/tbt40/tbt40.tbh',
            'libraries/tibbits/tbt40/tbt40.tbs',
            'libraries/ssi/ssi.tbh',
            'libraries/ssi/ssi.tbs',
        ];
        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                required: true,
                default: '',
            },
            {
                id: 'USESSI',
                name: 'Mode',
                settingType: SettingType.OPTION,
                required: true,
                readonly: true,
                default: 'NO',
                options: [
                    {
                        name: 'I2C mode',
                        value: 'YES',
                    },
                    {
                        name: 'Direct I/O (bit-banging)',
                        value: 'NO',
                    },
                ],
            },
            {
                id: 'L1NAME',
                name: 'LN1 Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.WORD,
                default: '',
                required: true,
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getRange(): number {
        return this.range;
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        if (this.project.runtime === 'simulator') {
            return [];
        }

        const socket = Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id);
        const channelName = `${this.getSettingValue('NAME')}_CHANNEL`;
        const range = this.getRange();
        const impedance = this.getSettingValue('L1NAME');

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    '${this.name} on socket ${this.getSettingValue('SOCKET')}
    '================================================================
    select case tbt40_init(YES,${this.getSettingValue('NAME')}_CLK,${this.getSettingValue('NAME')}_DATA,${this.getSettingValue('NAME')}_CHANNEL)
    case TBT40_SELFTEST_FAILED:
        sys.debugprint("Tibbit not found or malfunctioning\\r\\n")
        sys.halt

    case TBT40_NO_SSI_AVAILABLE:
        sys.debugprint("SSI channel could not be allocated, using bit banging instead.\\r\\n")

    end select


    'Use F10 to step over the procedures below.

    'This sets the IC to the maximum impedance it can produce. Use a meter to measure the actual impedance. It will be quite different from the nominal value.
    'Our IC sample gave us the value of 9080 Ohm for the 10KOhm IC.
    tbt40_set(256,NO,${this.getSettingValue('NAME')}_CHANNEL)

    'This sets the impedance to (close to) 5KOhm and saves the impendance into the ICs EEPROM
    tbt40_set_ohm(${this.getSettingValue('NAME')}_FULL_SCALE/2,${this.getSettingValue('NAME')}_FULL_SCALE,YES,${this.getSettingValue('NAME')}_CHANNEL)

    'This sets the impedance to (close to) 7KOhm without saving the new value into the EEPROM
    tbt40_set_ohm(${this.getSettingValue('NAME')}_FULL_SCALE/3,${this.getSettingValue('NAME')}_FULL_SCALE,NO,${this.getSettingValue('NAME')}_CHANNEL)

    'Power cycle your system. The first value (5KOhm) will be recalled because it was stored into the EEPROM while the second value (7KOhm) wasn't.
    '-----------------------------------------------------------------
        `,
        });

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `
declare ${this.getSettingValue('NAME')}_CHANNEL as byte`,
        });

        blocks.push({
            location: 'GLOBAL_DIMS',
            blockType: BlockType.CODE,
            template: `
dim ${this.getSettingValue('NAME')}_CHANNEL as byte`,
        });

        blocks.push({
            location: 'GLOBAL_CONSTS',
            blockType: BlockType.CODE,
            template: `
const ${this.getSettingValue('NAME')}_FULL_SCALE=46000 '<<========================================== CHANGE AS NEEDED
const ${this.getSettingValue('NAME')}_CLK=${socket?.pins[0]}
const ${this.getSettingValue('NAME')}_DATA=${socket?.pins[1]}

            `,
        });

        blocks.push({
            location: `var_${impedance}_changed`,
            blockType: BlockType.CODE,
            template: `tbt40_set_ohm(${impedance} * ${range}, ${range},NO,${channelName})`,
        });

        return blocks;
    }
}
